<script setup lang="ts">
import type { SignInCallbackType } from '@mixins'
import type { FirebaseTokenStatus } from '@firebaseModule'
import { FirebaseDevice } from '@store'

definePageMeta({
  layout: 'call-back',
})

useSetSEO()

const route = useRoute()
const { sender } = usePostMessage()
const { cookieNames, getCookie } = useCookies()

onBeforeMount(() => {
  const fcmTokenStatus = getCookie<FirebaseTokenStatus>(
    cookieNames.FCM_TOKEN_STATUS
  ) || {
    fcmDevice: FirebaseDevice.WEB,
    fcmAppToken: '',
    fcmWebToken: '',
  }

  const payload: SignInCallbackType = {
    userCmmnSn: Number(route.query.userCmmnSn),
    userSn: Number(route.query.userSn),
    autoLogin: route.query.autoLogin === 'true',
    fcmDevice: fcmTokenStatus.fcmDevice,
    firstCheckBlockAccess: true,
    cf1: route.query.cf1 ? String(route.query.cf1) : '',
    cf2: route.query.cf2 ? String(route.query.cf2) : '',
    cf3: route.query.cf3 ? String(route.query.cf3) : '',
  }

  if (route.query.deepLink && route.query.deepLink !== 'null') {
    payload.deepLink = String(route.query.deepLink)
  }

  sender(
    'opener',
    {
      res: payload,
      type: 'signin',
    },
    true
  )
})
</script>

<template>
  <NovaLoadingIndicator :bg-bright="'light'" :fill="true" />
</template>
